import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Property } from '../../anagraphics/property';

@Injectable({
  providedIn: 'root',
})
export class PropertyService {
  private readonly queryEndpoint = `${environment.api}/immobile-query/immobile`;
  private readonly commandEndpoint = `${environment.api}/immobile-command/immobile`;

  constructor(private http: HttpClient) {}

  getByPersonaFisica(personaFisicaId: string) {
    return this.http.get<Property[]>(
      `${this.queryEndpoint}/persona-fisica/${personaFisicaId}`
    );
  }

  getByPersonaGiuridica(personaGiuridicaId: string) {
    return this.http.get<Property[]>(
      `${this.queryEndpoint}/persona-giuridica/${personaGiuridicaId}`
    );
  }

  create(
    formData: Partial<Property>,
    personaFisicaId: string | undefined,
    personaGiuridicaId?: string
  ) {
    let body = this.propertyBody(formData, personaFisicaId, personaGiuridicaId);
    return this.http.post(this.commandEndpoint, body, { responseType: 'text' });
  }

  edit(
    formData: Partial<Property>,
    propertyId: string,
    personaFisicaId: string | undefined,
    personaGiuridicaId?: string
  ) {
    let body = this.propertyBody(formData, personaFisicaId, personaGiuridicaId);
    return this.http.put(`${this.commandEndpoint}/${propertyId}`, body);
  }

  delete(propertyId: string) {
    return this.http.delete(`${this.commandEndpoint}/${propertyId}`);
  }

  private propertyBody(
    formData: Partial<Property>,
    personaFisicaId?: string,
    personaGiuridicaId?: string
  ) {
    if (personaFisicaId) {
      formData.personaFisicaId = personaFisicaId;
    } else if (personaGiuridicaId) {
      formData.personaGiuridicaId = personaGiuridicaId;
    }
    return formData;
  }
}
